import { render, staticRenderFns } from "./UserSessionsList.vue?vue&type=template&id=0d5d665d&scoped=true&"
import script from "./UserSessionsList.vue?vue&type=script&lang=ts&"
export * from "./UserSessionsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5d665d",
  null
  
)

export default component.exports